<template>
  <v-app light>
    <v-content>
      <v-container v-show="showMain" fluid>
        <v-row justify="center" align="center" style="height: 100pt">
          <v-card flat>
            <v-img :width="logoImageWidth" :src="getLogoSrc()"></v-img>
          </v-card>
        </v-row>
        <v-row>
          <v-col :cols="(enabledTxType.length === 1) ? 4 : 2" />
          <v-col cols="4" v-for="(txType, idx) in enabledTxType" :key="'txType-col-' + idx">
            <v-card class="mx-auto" @click="doOrder(txType.command)" align="center" flat>
              <v-img width="260" :src="txType.icon" :style="`border:2px solid ${$vuetify.theme.themes.light.primary};
                border-radius: 10%`">
              </v-img>
              <v-card-text class="title font-weight-bold" align="center">
                <div v-show="language === 'zh_TW'">{{ txType.name }}</div>
                <div v-show="language === 'en_US'">{{ txType.englishName }}</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col :cols="(enabledTxType.length === 1) ? 4 : 2" />
        </v-row>
        <v-row v-show="isEnableDelivery">
          <v-col cols="4" />
          <v-col cols="4">
            <v-card class="mx-auto" @click="doOrder('delivery')" align="center" flat>
              <v-img width="260" :src="require('../assets/image/ic_delivery.png')" :style="`border:2px solid
              ${this.$vuetify.theme.themes.light.primary} border-radius: 10%`">
              </v-img>
              <v-card-text class="title font-weight-bold" align="center">
                <div v-show="language === 'zh_TW'">外送</div>
                <div v-show="language === 'en_US'">DELIVERY</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="4" />
        </v-row>
        <v-row>
          <v-col cols="12" align="center">
            <v-btn v-show="language !== 'en_US'" text class="title font-weight-bold" x-large color="primary"
              @click="switchLanguage('en_US')"><u>ENGLISH</u>
            </v-btn>
            <v-btn v-show="language !== 'zh_TW'" text class="title font-weight-bold" x-large color="primary"
              @click="switchLanguage('zh_TW')"><u>中文</u>
            </v-btn>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="10" md="8">
            <v-divider :thickness="2"></v-divider>
          </v-col>
        </v-row>
        <v-row justify="center">
          <v-col cols="8" sm="6" md="4">
            <p>公司名稱：<span>{{ storeSetting.storeName || '' }}</span></p>
            <p>統一編號：<span>{{ store0.storeTaxId || '' }}</span></p>
            <p>聯繫方式：<span>{{ storeSetting.storeTel || '' }}</span></p>
            <div class="text-start">
              <a @click="dialog = true">退貨政策</a>
              <v-dialog v-model="dialog" width="400">
                <v-card>
                  <v-card-title class="text-h6">
                    退貨政策
                  </v-card-title>
                  <v-card-text style="white-space: pre-line;">
                    {{ storeSetting.returnPolicy || '' }}
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog = false">Ok</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <v-container v-show="showSelectSub" fluid>
        <v-row justify="center" align="center" style="height: 100pt">
          <v-card flat>
            <v-img :width="logoImageWidth" :src="getLogoSrc()"></v-img>
          </v-card>
        </v-row>
        <v-row>
          <v-col cols="6" v-for="(item, index) in subStores" :key="'sub-stores-col-' + index">
            <v-card class="mx-auto" align="center" @click="selectSubStore(item.contractNo)" flat>
              <v-img width="260" :src="require('../assets/image/ic_shop.png')"
                :style="`border:2px solid border-radius: 10%`">
              </v-img>
              <v-card-text class="title font-weight-bold" align="center">
                <div>{{ item.storeName }}</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
    <v-footer v-show="subStores.length && showMain" padless app color="white">
      <v-container fluid>
        <v-row class="pa-0">
          <v-col class="pr-0 pl-0">
            <v-btn class="subtitle-1 font-weight-bold" color="primary" @click="home" x-large block outlined>{{ (language
              ===
              'zh_TW') ? '回分店列表' : 'BRANCHES' }}
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </v-app>
</template>

<script>
// import localMenu from '../modules/menu.json';

import { deepCopy } from '../assets/functions/deepCopy';

const PosTransaction = require('../modules/pos_transaction');
const config = require('../modules/config.json');
const externalPosFactory = require('../modules/external_pos');

const base64Decode = (base64String) => Buffer.from(base64String, 'base64').toString('utf-8');

export default {
  name: 'MainPage',
  components: {},
  props: {},
  data: () => ({
    showMain: false,
    showSelectSub: false,
    dialogSetup: false,
    storeExt: '', // 部門店家與有其他單位合作(百貨店)，由query string 傳入,
    skipBeforeOrder: false,
    txTypeInfo: {
      201701000001: {
        name: '內用',
        englishName: 'HERE',
        icon: require('@/assets/image/ic_eatin.png'),
        command: 'for-here',
      },
      201701000002: {
        name: '外帶',
        englishName: 'TOGO',
        icon: require('@/assets/image/ic_takeout.png'),
        command: 'to-go',
      },
    },
    dialog: false,
  }),
  methods: {
    getLogoSrc() {
      const setting = this.$store.getters.storeSetting;
      if (setting.kioskLoginImage?.url) {
        return setting.kioskLoginImage.url + setting.kioskLoginImage.file_name;
      }
      return '';
    },
    setProfile(profile) {
      // 一般單位(子公司)
      const ext = this.storeExt;
      const payload = {
        orderNo: '', tableIndexNo: '', people: false, no: profile.contractNo, skipBeforeOrder: this.skipBeforeOrder, ...profile,
      };
      if (ext) {
        const _ext = base64Decode(ext).split('#');
        if (_ext.length === 2) { // 0: location, 1: counter no
          const _info = config.externalPOS.find((element) => element.name === _ext[0]);
          payload.extPos = {
            ext,
            label: _info.label,
            counterNo: _ext[1],
            func: externalPosFactory[_info.name],
          };
        }
      }
      const { order: orderNoString, tableIndex, people: peopleValue } = this.$route.query;
      if (orderNoString) {
        const orderNo = base64Decode(orderNoString);
        payload.orderNo = orderNo;
      }
      if (tableIndex) {
        payload.tableIndexNo = tableIndex;
      }
      if (peopleValue && peopleValue === 'true') {
        payload.people = true;
      }
      this.$store.dispatch('setProfile', payload);
    },
    async selectSubStore(contractNo) {
      const profile = await PosTransaction.getProfile(contractNo);

      if (profile) {
        this.setProfile(profile);
        this.showSelectSub = false;
        this.showMain = true;
      }
    },
    doOrder(diningIn) {
      this.$store.dispatch('setDiningIn', diningIn);
      this.goNext();
    },
    goNext() {
      const next = this.$store.getters.nextStatusText;
      this.$router.push(next);
    },
    handleDialogClose() {
    },
    switchLanguage(language) {
      this.language = language;
    },
    home() {
      this.showSelectSub = true;
      this.showMain = false;
    },
  },
  async created() {
    this.$store.dispatch('setStatus', 'HOME');

    // 清空 store
    this.$store.dispatch('cleanUtilsData');
    this.$store.dispatch('cleanOrder');
    this.$store.dispatch('cleanProfile');

    const {
      main, no: contractNoString, ext, kiosk, skip: skipBeforeOrder, order: orderNoString, tableIndex,
      transactionId: TPtransactionId, status: TPstatus,
    } = this.$route.query;

    if (contractNoString) {
      const contractNo = base64Decode(contractNoString);
      const profile = await PosTransaction.getProfile(contractNo);
      // console.log('profile', profile);

      // 設定cashType
      const cashType = profile?.storeInfo?.store?.[0]?.setting?.cashType;
      if (cashType) {
        this.$store.dispatch('setCashType', cashType);
      }

      if (profile && profile.token) {
        this.storeExt = ext;
        // 跳過內用選點人數
        if (skipBeforeOrder && skipBeforeOrder === 'true') {
          this.skipBeforeOrder = true;
        }
        this.setProfile(profile);
        // 群組總公司
        if (main && main === 'true') {
          // 取分店資訊
          const subStores = await PosTransaction.getSubStoreNo(profile.token, contractNo);
          // 總店也當作分店出現
          // subStores.unshift({ contractNo: profile.contractNo });
          this.subStores = subStores;
          this.showSelectSub = true;
        } else {
          this.showMain = true;
        }

        // 設定TapPay
        const _tappay = this.$store.getters.storePaymentType
          .find((type) => (type.paymentTypeName === 'TapPay') && (type.isShowOnList && type.isShowOnList === 'Y'));
        if (_tappay) {
          const TapPayInfo = deepCopy(_tappay.paymentAddtionalInfo);
          const { appID, appKey, serverType } = TapPayInfo;
          TPDirect.setupSDK(appID, appKey, serverType);
        }

        // 訂單由無人櫃台(繳費機)處理
        if (kiosk && kiosk === 'true') {
          await this.$store.dispatch('setIsForKiosk', true);
        }

        let hasQrcode = false;
        // 是否有status跟transactionId
        if (TPstatus && TPtransactionId) {
          const { token, storeId } = this.$store.getters;
          const id = TPtransactionId.split('?')[0];
          const transactionRes = await PosTransaction.getTransactionByIdPostInfo(token, id, storeId, hasQrcode);
          if (transactionRes?.[0]) {
            const { transactionTypeId, transactionStatusId, log } = transactionRes[0];
            // console.log('transaction res', transactionRes[0]);
            // 結帳成功
            if (TPstatus === '0') {
              if (transactionStatusId === '12') {
                await new Promise((resolve) => setTimeout(resolve, 1500));
              } else {
                this.$store.dispatch('settContent', transactionRes[0]);
                this.$router.push({ name: 'done-page' });
              }
            } else {
              // eslint-disable-next-line no-lonely-if
              if (transactionStatusId === '12') {
                this.$store.dispatch('settContent', transactionRes[0]);
                this.$store.dispatch('setOnlyDoPrime', true);
                if (transactionTypeId === '201701000001') {
                  this.$store.dispatch('setDiningIn', 'for-here');
                } else {
                  this.$store.dispatch('setDiningIn', 'to-go');
                }
                this.$store.dispatch('setOrderContent',
                  { storeName: this.$store.getters.storeSetting.storeName });
                log.forEach((element) => {
                  this.$store.dispatch('setOrderItem', element.product);
                });
                this.$router.push({ name: 'payment-page' });
              }
            }
            // 結帳失敗
          }
        }

        // 有訂單
        if (orderNoString) {
          const { token, storeId } = this.$store.getters;
          const orderNo = base64Decode(orderNoString);
          hasQrcode = true;
          const QrcodeRes = await PosTransaction.getTransactionByIdPostInfo(token, orderNo, storeId, hasQrcode);
          if (QrcodeRes?.[0]) {
            const {
              guests, tableId, clientTransactionId, transactionId, transactionTypeId,
              transactionStatusId, log, serviceCharge, receiveTotal, // transactionPaymentList, test
            } = QrcodeRes[0];
            // console.log('Qr res', QrcodeRes[0]);
            // if (transactionStatusId !== '12' || transactionPaymentList.length > 0) {
            if (transactionStatusId !== '12') {
              this.$router.push({ name: 'invalid-page' });
            } else {
              this.$store.dispatch('setQrcodeData', {
                transactionTypeId, guests, tableId, clientTransactionId, transactionId,
              });
              if (transactionTypeId === '201701000001') {
                this.$store.dispatch('setDiningIn', 'for-here');
              }
              if (guests?.length > 0) {
                this.$store.dispatch('setOrderContent', { guests });
              }
              if (tableId?.length > 0) {
                this.$store.dispatch('setOrderContent', { tableId });
              }
              if (log.length > 0) {
                this.$store.dispatch('setPreviousOrder', log);
                this.$store.dispatch('setPreviousTotal', {
                  previousTotalServiceFee: serviceCharge,
                  previousTotalAmount: receiveTotal,
                });
              }
              this.$store.dispatch('setStatus', 'ORDER');
              this.$router.push({ name: 'order-page' });
            }
          }
        }
        // 有桌號
        if (tableIndex) {
          const { tableInfo } = this.$store.getters;
          if (tableInfo[tableIndex - 1]) {
            const { tableId } = tableInfo[tableIndex - 1];
            this.$store.dispatch('setDiningIn', 'for-here');
            this.$store.dispatch('setOrderContent', { tableId });
            this.$router.push({ name: 'order-page' });
          }
        }
      }
    }
  },
  computed: {
    logoImageWidth() {
      if (this.$vuetify.breakpoint.name === 'xs') {
        return '218px';
      }
      return '467px';
    },
    language: {
      get() {
        return this.$store.getters.language;
      },
      set(value) {
        this.$store.dispatch('setLanguage', value);
      },
    },
    isDynamicQrcode() {
      return this.$store.getters.isDynamicQrcode;
    },
    isEnableDelivery() {
      return this.$store.getters.isEnableDelivery && this.$store.getters.deliveryVender !== 'none';
    },
    isDisableTakeout() {
      // 取消外帶選項，在後台設定裏，將外帶等待時間設定為disable
      return this.$store.getters.storeSetting?.waitTime === 'disable';
    },
    subStores: {
      get() {
        return this.$store.getters.subStores;
      },
      set(value) {
        this.$store.dispatch('setSubStores', value);
      },
    },
    enabledTxType() {
      const enabledType = [];
      const { kioskTransactionType } = this.$store.getters.storeSetting;
      // 如果沒有這個欄位的話，預設都啟用
      if (kioskTransactionType === undefined) {
        return this.txTypeInfo;
      }

      if (Array.isArray(kioskTransactionType)) {
        kioskTransactionType.forEach((type) => {
          const _typeInfo = this.txTypeInfo[type];
          if (_typeInfo) {
            enabledType.push(_typeInfo);
          }
        });
      }
      // console.log('enabledType', enabledType);
      return enabledType;
    },
    storeSetting() {
      const result = this.$store.getters?.storeSetting || {};
      return result;
    },
    store0() {
      const result = this.$store.getters?.store0 || {};
      return result;
    },
  },
};

</script>
<style></style>
